// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title>Edit Profile</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="blue" @click="saveUser">Save</v-btn>
      </v-toolbar>
      <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Name"
            v-model="user.name"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Username"
            :rules="[emailRule]"
            v-model="user.username"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            v-bind:items="roles"
            v-model="user.roles"
            item-text="name"
            item-value="id"
            multiple
            chips
            label="User Roles"
            disabled
          ></v-select>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            v-bind:items="customers"
            v-model="user.securityCtx.customers"
            item-text="name"
            item-value="_id"
            multiple
            chips
            label="Customers"
            disabled
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="New Password"
            v-model="passwordReset1"
            required
            :rules="[passwordRule, passwordsEqual]"
            type="password"
            counter :min="passwordLength">
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Verify New Password"
            v-model="passwordReset2"
            required
            :rules="[passwordRule, passwordsEqual]"
            type="password"
            counter :min="passwordLength">
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    </v-card>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import {AXIOSAPI} from '@/api/api'
import ApiRequests from '@/api/ApiRequests'
import {WILDCARDBSON} from 'vue-common/components/constants'
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'

import Rules from 'vue-common/components/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      customers: [],
      endpoint: ENDPOINT,
      errorText: '',
      passwordLength: Rules.PASSWORDLENGTH,
      passwordReset1: '',
      passwordReset2: '',
      roles: [],
      // User needs these empty fields or the field rules don't like it.
      user: {
        password: '',
        username: '',
        securityCtx: {
          customers: []
        }
      }
    }
  },

  created () {
    this.getUser()

    ApiRequests.getCustomers().then((response) => {
      this.customers = response.data
      if (this.allCustomers) {
        this.customers.unshift({name: 'All Customers', _id: WILDCARDBSON})
      }
    })

    ApiRequests.getRoles().then((response) => {
      this.roles = response.data
    })
  },

  computed: {
    ...mapGetters({
      activeAccessRules: 'accessRules',
      activeUser: 'user',
      allCustomers: 'allCustomers'
    }),

    passwordsEqual: function () {
      if ((this.passwordReset1 === this.passwordReset2) || this.passwordReset2.length === 0) {
        return true
      } else {
        return 'Passwords are not the same'
      }
    }
  },

  methods: {
    getUser: function () {
      AXIOSAPI.get(ENDPOINT + 'users/me').then((response) => {
        this.user = response.data
        if (!(this.user.securityCtx.customers)) {
          this.user.securityCtx.customers = []
        }
      })
    },

    saveUser: function () {
      if (this.user.name && (this.emailRule(this.user.username) === true)) {
        if (this.passwordReset1.length > 0) {
          if (Rules.password(this.passwordReset1) !== true || this.passwordsEqual !== true) {
            this.errorText = 'Passwords must match'
            return
          } else {
            this.user.password = this.passwordReset1
          }
        }

        AXIOSAPI.put(ENDPOINT + 'users/me', this.user).then(response => {
          this.exit()
        }).catch(e => {
          console.log(e)
          this.errorText = e.response.statusText + ': ' + e.response.data
        })
      } else {
        this.errorText = 'Please fill out all required fields'
      }
    },

    emailRule: function (address) {
      var re = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{2,}$/
      if (re.test(address)) {
        return true
      } else {
        return 'Not a valid email address'
      }
    },

    passwordRule: function (password) {
      return Rules.password(password)
    },

    exit: function () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserMe.vue